import shiftBoxIconComponentUrl from './shiftBoxIconComponent.html';

class ShiftBoxIconController {
  constructor(Authentication, AbsenceUtils, AvailabilityUtils, sdk) {
    'ngInject';

    this.user = Authentication.user;
    this.NO_SHOW_TYPE = sdk('constants').NO_SHOW_TYPE;
    this.SICK_CALLOUT_TYPE = sdk('constants').SICK_CALLOUT_TYPE;
    this.UNAVAILABILITY_TYPE = sdk('constants').UNAVAILABILITY_TYPE;

    Object.assign(this, { AbsenceUtils, AvailabilityUtils, sdk });
  }

  $onInit() {
    this.iconShown = this.shouldRenderIcon(); // binds out
  }

  shouldRenderIcon() {
    const { showOfferedShiftIcon, showAvailableShiftIcon, showTimeoffIcon, exchangeData, slots } =
      this.event;
    return (
      showOfferedShiftIcon ||
      showAvailableShiftIcon ||
      showTimeoffIcon ||
      exchangeData?.isSwap ||
      slots > 1 ||
      this.AbsenceUtils.isAbsenceEvent(this.event) ||
      this.isPendingUnavailability()
    );
  }

  isMyAcceptedOffer() {
    return this.event.offer.user && this.event.offer.accepted && this.event.offer.user.isMe;
  }

  isMyApplication() {
    return !this.user.isManager && this.event.showAvailableShiftIcon && this.event.myApplication;
  }

  shouldShowNoShowIcon() {
    return this.event.type === this.NO_SHOW_TYPE;
  }

  shouldShowSickCalloutIcon() {
    return this.event.type === this.SICK_CALLOUT_TYPE;
  }

  shouldShowAvatar() {
    return (this.event.showOfferedShiftIcon && this.isMyAcceptedOffer()) || this.isMyApplication();
  }

  isShiftSwap() {
    return this.event.exchangeData?.isSwap;
  }

  isPendingUnavailability() {
    return (
      this.event.type === this.UNAVAILABILITY_TYPE && this.AvailabilityUtils.isRequest(this.event)
    );
  }
}

export default {
  templateUrl: shiftBoxIconComponentUrl,
  controller: ShiftBoxIconController,
  controllerAs: 'ctrl',
  bindings: {
    event: '<',
    iconShown: '=?',
    slotsShown: '=?',
    smallAvatar: '<?',
  },
};
